export default "__VITE_ASSET__BtuaXRL$__"